export default "__VITE_ASSET__6b20100e__"